// File: src/pages/CompleteOrder.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  Input,
  Button,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  Form,
  FormGroup,
  Label,
} from "reactstrap";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import swal from "sweetalert";
import {
  FaFileExcel,
  FaSlidersH,
  FaChevronRight,
  FaChevronDown,
} from "react-icons/fa";
import { AiOutlineDownload } from "react-icons/ai";

import axios from "axios";
import { pdf } from "@react-pdf/renderer";
import LatestInvoice from "./LastestInvoice";

import {
  _Get,
  _Put,
  _PutUpdate,
  _DeleteAllSales,
} from "../import/ApiEndPoint/ApiCalling";
import { CheckPermission } from "../import/CheckPermission";
import {
  Last_Ledger_Balance,
  arnSave,
  updatedCNData,
  View_Customer_ById,
  ViewOne_Product,
} from "../import/ApiEndPoint/Api";
import { baseURL } from "../import/ApiEndPoint/TestApi";
import { ToWords } from "to-words";
import { useNavigate } from "react-router-dom";
import LinkCell from "../components/LinkCell";

const clearGlobalSalesFastCaches = () => {
  window.__dmsSalesPageSummaryCache?.clear?.();
  window.__dmsSalesPageBootstrapCache?.clear?.();
  window.__dmsSalesPartyLedgerCache?.clear?.();
};


/* ============== tiny page-scoped CSS ============== */
const injectOnce = () => {
  if (document.getElementById("completeorder-inline-css")) return;
  const style = document.createElement("style");
  style.id = "completeorder-inline-css";
  style.innerHTML = `
    .co-toolbar .count-pill{
      background:#eef2ff; color:#3730a3; font-weight:800; padding:6px 10px; border-radius:999px;
    }

    .co-card{
      border-radius:14px;
      border:1px solid #e5e7eb;
      background:#fff;
    }

    .co-toolbar-shell{
      padding: 10px 10px;
      border-radius: 14px;
      border: 1px solid #e5e7eb;
      background: #f4f7f6;
    }

    .co-row{
      display:flex;
      gap:10px;
      flex-wrap:nowrap;
      align-items:center;
      overflow:hidden;
    }
    @media (max-width: 1200px){
      .co-row{ flex-wrap:wrap; }
    }

    .co-title{
      font-weight: 900;
      text-transform: uppercase;
      font-size: 18px;
      letter-spacing: .02em;
      color:#0f172a;
      display:flex;
      align-items:center;
      gap:8px;
      white-space:nowrap;
    }

    .co-mini-tabs{
      display:flex;
      align-items:center;
      gap:6px;
      flex:0 0 auto;
    }
    .co-mini-tab{
      height:28px;
      padding:0 10px;
      border-radius:999px;
      border:1px solid #dbe3ef;
      background:#fff;
      color:#0f172a;
      font-size:11px;
      font-weight:900;
      text-transform:uppercase;
      letter-spacing:.03em;
      cursor:pointer;
      display:inline-flex;
      align-items:center;
      justify-content:center;
      white-space:nowrap;
    }
    .co-mini-tab.active{
      background:#2563eb;
      border-color:#2563eb;
      color:#fff;
      box-shadow:0 10px 18px rgba(37,99,235,.18);
    }

    .co-spacer{ flex: 1 1 auto; min-width: 10px; }

    .co-search{
      width: 260px;
      max-width: 340px;
      flex: 0 0 auto;
    }
    .co-search input{
      background:#fff;
      border-radius: 12px;
      border:1px solid #e5e7eb;
      font-weight: 800;
      height: 32px;
    }

    .co-btn-soft{
      height:32px;
      border-radius:12px;
      border:1px solid #e5e7eb;
      background:#ffffff;
      font-weight:900;
      text-transform:uppercase;
      padding:0 10px;
      display:inline-flex;
      align-items:center;
      gap:8px;
      box-shadow: 0 8px 16px rgba(0,0,0,0.04);
      cursor:pointer;
      user-select:none;
      white-space:nowrap;
      flex: 0 0 auto;
    }
    .co-btn-soft:hover{
      box-shadow: 0 12px 22px rgba(0,0,0,0.08);
      transform: translateY(-1px);
    }

    .co-chip{
      height: 30px;
      padding: 0 10px;
      border-radius: 999px;
      border: 1px solid #e5e7eb;
      background:#fff;
      display:inline-flex;
      align-items:center;
      gap:6px;
      font-weight:900;
      color:#0f172a;
      text-transform:uppercase;
      letter-spacing:.02em;
      font-size: 12px;
      white-space:nowrap;
      flex: 0 0 auto;
    }

    .co-field{
      height:32px;
      border-radius:12px;
      border:1px solid #e5e7eb;
      background:#fff;
      padding:0 10px;
      display:inline-flex;
      align-items:center;
      gap:8px;
      flex: 0 0 auto;
      white-space:nowrap;
    }
    .co-field .lbl{
      font-size:11px;
      font-weight:900;
      letter-spacing:.03em;
      text-transform:uppercase;
      color:#6b7280;
      margin:0;
    }
    .co-field select{
      height:28px;
      border:none;
      outline:none;
      background:transparent;
      font-weight:900;
      padding:0;
      min-width: 110px;
    }
    .co-field select.sm{ min-width: 120px; }
    .co-field select.xs{ min-width: 130px; }

    .co-table-wrap{
      width:100%;
      overflow:auto;
      border:1px solid #e5e7eb;
      border-radius:14px;
      background:#fff;
    }
    .co-table{ width:100%; border-collapse:collapse; table-layout:auto; min-width:980px; }
    .co-table thead th{
      background:#f4f7f6; color:#0f172a; font-weight:800; text-transform:uppercase; font-size:12px; letter-spacing:.03em;
      border-bottom:1px solid #e5e7eb; padding:6px 8px; position:sticky; top:0; z-index:1; text-align:center; white-space:nowrap;
    }
    .co-table tbody td{
      padding:8px 10px; border-bottom:1px solid #f1f5f9; vertical-align:middle; color:#0f172a; font-size:14px; text-align:center;
    }
    .co-table tbody tr:hover{ background:#f9fbff; }
    .co-totals{ font-weight:800; background:#fafafa; position:sticky; bottom:0; }
    .co-month-row{
      background:#eef6ff;
      font-weight:900;
      cursor:pointer;
    }
    .co-month-row:hover{
      background:#e4efff !important;
    }
    .co-month-cell{
      display:flex;
      align-items:center;
      gap:8px;
      justify-content:flex-start;
    }
    .co-month-muted{
      color:#64748b;
      font-weight:700;
    }

    .co-form .form-group { margin-bottom:8px; }
    .co-form label { font-size:12px; margin-bottom:4px; }
    .co-form input, .co-form select { font-size:12px; height:34px; }
  `;
  document.head.appendChild(style);
};

/* ============== helpers ============== */
const toStr = (v) => (v === null || v === undefined ? "" : String(v));
const fmtDate = (s) => (s ? String(s).split("T")[0] : "");
const INR = (n) => (n === 0 || n ? Number(n).toFixed(2) : "");
const N = (v) => {
  const num = Number(v);
  return isNaN(num) ? 0 : num;
};
const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

const isCompletedOrder = (row) => {
  const status = toStr(
    row?.status ?? row?.Status ?? row?.orderStatus ?? row?.invoiceStatus,
  )
    .trim()
    .toLowerCase();

  return status === "completed" || status === "complete";
};

const parseOrderDate = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value).trim();

  // Supports DD/MM/YYYY and DD-MM-YYYY, in addition to MongoDB ISO dates.
  const dmy = raw.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/);
  if (dmy) {
    const [, day, month, year] = dmy;
    const parsed = new Date(Number(year), Number(month) - 1, Number(day));
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

/* ============== FY-wise Prefix/Suffix helpers ============== */
const getInvoiceFYLabel = (dateValue = new Date()) => {
  const d = new Date(dateValue || new Date());
  const month = d.getMonth(); // Jan = 0, Apr = 3
  const year = d.getFullYear();

  const startYear = month >= 3 ? year : year - 1;
  const endShort = String(startYear + 1).slice(-2);

  return `${startYear}-${endShort}`;
};

const normalizeFY = (fy) => {
  const s = toStr(fy)
    .replace(/^FY\s*/i, "")
    .trim();

  const fullMatch = s.match(/^(\d{4})-(\d{4})$/);
  if (fullMatch) {
    return `${fullMatch[1]}-${fullMatch[2].slice(-2)}`;
  }

  const shortMatch = s.match(/^(\d{4})-(\d{2})$/);
  if (shortMatch) return s;

  return s;
};

const parseInvoiceSeries = (company = {}) => {
  let raw =
    company?.invoiceSeries ||
    company?.invoicePrefixSuffix ||
    company?.prefixSuffixByFY ||
    [];

  if (typeof raw === "string") {
    try {
      raw = JSON.parse(raw);
    } catch {
      raw = [];
    }
  }

  return Array.isArray(raw)
    ? raw
        .map((x) => ({
          financialYear: normalizeFY(x?.financialYear || x?.fy || ""),
          Prefix: x?.Prefix ?? x?.prefix ?? "",
          Suffix: x?.Suffix ?? x?.suffix ?? "",
        }))
        .filter((x) => x.financialYear)
    : [];
};

const getInvoicePrefixSuffixByDate = (company = {}, dateValue) => {
  const invoiceFY = getInvoiceFYLabel(dateValue);
  const series = parseInvoiceSeries(company);

  const found = series.find(
    (x) => normalizeFY(x.financialYear) === normalizeFY(invoiceFY),
  );

  if (found) {
    return {
      Prefix: found.Prefix || "",
      Suffix: found.Suffix || "",
      financialYear: invoiceFY,
    };
  }

  return {
    Prefix: company?.Prefix || "",
    Suffix: company?.Suffix || "",
    financialYear: invoiceFY,
  };
};

const formatInvoiceNoByFY = (invoiceRow, company = {}) => {
  if (!invoiceRow || invoiceRow?.invoiceId === undefined) return "";

  const dateValue = invoiceRow?.date || invoiceRow?.createdAt || new Date();
  const { Prefix, Suffix } = getInvoicePrefixSuffixByDate(company, dateValue);

  return `${Prefix || ""}${invoiceRow?.invoiceId || ""}${Suffix || ""}`;
};

/* ============== “Print payload” sanitizer ============== */
const printableEntityId = (value) => {
  if (!value) return "";
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }
  if (typeof value === "object") {
    return String(value?._id || value?.id || "");
  }
  return "";
};

const getPrintableProductId = (item = {}) =>
  printableEntityId(item?.productId) ||
  printableEntityId(item?.productData) ||
  printableEntityId(item?._productDetailsFromProductList) ||
  printableEntityId(item?.productDetails) ||
  printableEntityId(item?.product) ||
  printableEntityId(item?.pId) ||
  printableEntityId(item?.ProductId);

const hasPrintableProductName = (item = {}) => {
  const product =
    item?._productDetailsFromProductList ||
    item?.productData ||
    item?.productDetails ||
    item?.product ||
    (typeof item?.productId === "object" ? item.productId : {}) ||
    {};

  return !!toStr(
    item?.Product_Title ||
      item?.productName ||
      item?.ProductName ||
      product?.Product_Title ||
      product?.productName ||
      product?.ProductName ||
      product?.name,
  ).trim();
};

const hasPrintableProductHSN = (item = {}) => {
  const product =
    item?._productDetailsFromProductList ||
    item?.productData ||
    item?.productDetails ||
    item?.product ||
    (typeof item?.productId === "object" ? item.productId : {}) ||
    {};

  return !!toStr(
    item?.HSN_Code ||
      item?.HSN ||
      item?.hsnCode ||
      item?.HSNCode ||
      product?.HSN_Code ||
      product?.HSN ||
      product?.hsnCode ||
      product?.HSNCode ||
      product?.hsn,
  ).trim();
};

const hydrateInvoiceMasterDetails = async (rawRow = {}) => {
  const row = JSON.parse(JSON.stringify(rawRow || {}));

  // Customer master is the source of truth for Bill To / Ship To GST and address.
  const partyId =
    printableEntityId(row?.partyId) ||
    printableEntityId(row?.customerId) ||
    printableEntityId(row?.customer);
  if (partyId) {
    try {
      const customerRes = await _Get(View_Customer_ById, partyId);
      const customer =
        customerRes?.Customer ||
        customerRes?.customer ||
        customerRes?.data?.Customer ||
        customerRes?.data?.customer ||
        {};

      if (customer && Object.keys(customer).length) {
        const embeddedParty =
          row?.partyId && typeof row.partyId === "object" ? row.partyId : {};
        row.partyId = { ...embeddedParty, ...customer };
      }
    } catch (err) {
      console.warn("Could not hydrate customer details for invoice PDF", err);
    }
  }

  // Some historical invoices only store product IDs. Fetch only products whose
  // printable name or HSN is missing, and reuse each master product once.
  const orderItems = Array.isArray(row?.orderItems) ? row.orderItems : [];
  const missingProductIds = [
    ...new Set(
      orderItems
        .filter(
          (item) =>
            !hasPrintableProductName(item) || !hasPrintableProductHSN(item),
        )
        .map((item) => getPrintableProductId(item))
        .filter(Boolean),
    ),
  ];

  if (missingProductIds.length) {
    const productPairs = await Promise.all(
      missingProductIds.map(async (productId) => {
        try {
          const productRes = await _Get(ViewOne_Product, productId);
          const product =
            productRes?.Product ||
            productRes?.product ||
            productRes?.data?.Product ||
            productRes?.data?.product ||
            productRes?.data ||
            {};
          return [productId, product];
        } catch (err) {
          console.warn(
            `Could not hydrate product ${productId} for invoice PDF`,
            err,
          );
          return [productId, null];
        }
      }),
    );

    const productMap = new Map(
      productPairs.filter(([, product]) => product && Object.keys(product).length),
    );

    row.orderItems = orderItems.map((item) => {
      const productId = getPrintableProductId(item);
      const masterProduct = productMap.get(productId);
      if (!masterProduct) return item;

      const embeddedProduct =
        item?.productId && typeof item.productId === "object"
          ? item.productId
          : {};

      return {
        ...item,
        productId: { ...embeddedProduct, ...masterProduct },
        productData: { ...(item?.productData || {}), ...masterProduct },
        Product_Title:
          item?.Product_Title ||
          item?.productName ||
          item?.ProductName ||
          masterProduct?.Product_Title ||
          masterProduct?.productName ||
          masterProduct?.ProductName ||
          masterProduct?.name ||
          "",
        HSN_Code:
          item?.HSN_Code ||
          item?.HSN ||
          item?.hsnCode ||
          item?.HSNCode ||
          masterProduct?.HSN_Code ||
          masterProduct?.HSN ||
          masterProduct?.hsnCode ||
          masterProduct?.HSNCode ||
          masterProduct?.hsn ||
          "",
      };
    });
  }

  return row;
};

function buildPrintableInvoice(rawRow, company) {
  const r = JSON.parse(JSON.stringify(rawRow || {}));

  if (r.invoiceId !== undefined) {
    r.invoiceId = formatInvoiceNoByFY(r, company);
  }

  if (!r.partyId || typeof r.partyId !== "object") {
    r.partyId = {
      CompanyName: r.fullName || "",
      contactNumber: r.MobileNo || "",
      State: r.state || "",
      City: r.city || "",
      Pincode: r.pincode || "",
      address: r.ownerAddress || r.address || "",
      email: r.email || "",
      gstNumber: r.gstNumber || "",
    };
  }

  if (Array.isArray(r.discountDetails)) {
    r.discountDetails = r.discountDetails.map((d) => ({
      ...d,
      type: toStr(d?.type).trim(),
      title:
        d?.title ||
        (toStr(d?.type).toLowerCase() === "charges" ? "Charges" : "Discount"),
      amount: N(d?.amount ?? d?.discountedAmount ?? d?.discountedValue ?? 0),
      discountedAmount: undefined,
      discountedValue: undefined,
    }));
  } else {
    r.discountDetails = [];
  }

  if (Array.isArray(r.orderItems)) {
    r.orderItems = r.orderItems.map((it) => {
      const qty = N(it?.qty);
      const price = N(it?.price);
      const totalPrice = N(it?.totalPrice) || round2(qty * price);
      let taxableAmount = N(it?.taxableAmount);
      if (taxableAmount === 0 || taxableAmount > totalPrice * 50) {
        taxableAmount = totalPrice;
      }
      const rate = N(it?.gstPercentage ?? it?.productId?.GSTRate);
      let grandTotal = N(it?.grandTotal);
      if (!grandTotal) {
        const isIGST = !!N(it?.igstRate);
        if (isIGST) grandTotal = round2(taxableAmount * (1 + rate / 100));
        else grandTotal = round2(taxableAmount * (1 + rate / 200 + rate / 200));
      }
      return { ...it, qty, price, totalPrice, taxableAmount, grandTotal };
    });
  } else {
    r.orderItems = [];
  }

  r.cgstTotal = round2(N(r.cgstTotal));
  r.sgstTotal = round2(N(r.sgstTotal));
  r.igstTotal = round2(N(r.igstTotal));
  r.roundOff = round2(N(r.roundOff));
  r.grandTotal = round2(N(r.grandTotal));
  if (r.coolieAndCartage === undefined) r.coolieAndCartage = 0;

  if (r.maxGstPercentage === undefined) {
    const maxRate = (r.orderItems || []).reduce(
      (m, it) => Math.max(m, N(it?.gstPercentage ?? it?.productId?.GSTRate)),
      0,
    );
    r.maxGstPercentage = maxRate;
  }

  r.igstTaxType = !!N(r.igstTaxType);

  return r;
}

/* ============== Amount-in-words ============== */
const toWords = new ToWords({
  localeCode: "en-IN",
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false,
    currencyOptions: {
      name: "Rupee",
      plural: "Rupees",
      symbol: "₹",
      fractionalUnit: { name: "Paisa", plural: "Paise", symbol: "" },
    },
  },
});

/* ============== FY helpers (Apr–Mar) ============== */
const getFYStartYear = (d = new Date()) => {
  const m = d.getMonth();
  const y = d.getFullYear();
  return m >= 3 ? y : y - 1;
};

const getSelectedFYStartYear = (financialYear) => {
  const normalized = normalizeFY(financialYear);
  const match = normalized.match(/^(\d{4})-(?:\d{2}|\d{4})$/);
  return match ? Number(match[1]) : getFYStartYear(new Date());
};

const buildFinancialYearDatabase = (database, financialYear) => {
  const base = toStr(database).trim();
  const fy = normalizeFY(financialYear);

  if (!base) return "";
  if (!fy) return base;

  const existingFYMatch = base.match(/(\d{4}-(?:\d{2}|\d{4}))$/);
  const existingFY = existingFYMatch ? normalizeFY(existingFYMatch[1]) : "";

  // Prevent values such as database-2025-26-2025-26.
  return existingFY === fy ? base : `${base}-${fy}`;
};

function computeRange({ fyStartYear, periodType, monthName, quarter, half }) {
  const fyStart = new Date(fyStartYear, 3, 1, 0, 0, 0, 0);
  const fyEnd = new Date(fyStartYear + 1, 2, 31, 23, 59, 59, 999);

  if (periodType === "YEARLY") return { start: fyStart, end: fyEnd };

  if (periodType === "HALF_YEARLY") {
    if (half === "H1") {
      return {
        start: new Date(fyStartYear, 3, 1, 0, 0, 0, 0),
        end: new Date(fyStartYear, 8, 30, 23, 59, 59, 999),
      };
    }
    return {
      start: new Date(fyStartYear, 9, 1, 0, 0, 0, 0),
      end: new Date(fyStartYear + 1, 2, 31, 23, 59, 59, 999),
    };
  }

  if (periodType === "QUARTERLY") {
    const map = {
      Q1: { sy: fyStartYear, sm: 3, ey: fyStartYear, em: 5, ed: 30 },
      Q2: { sy: fyStartYear, sm: 6, ey: fyStartYear, em: 8, ed: 30 },
      Q3: { sy: fyStartYear, sm: 9, ey: fyStartYear, em: 11, ed: 31 },
      Q4: { sy: fyStartYear + 1, sm: 0, ey: fyStartYear + 1, em: 2, ed: 31 },
    };
    const r = map[quarter || "Q1"];
    return {
      start: new Date(r.sy, r.sm, 1, 0, 0, 0, 0),
      end: new Date(r.ey, r.em, r.ed, 23, 59, 59, 999),
    };
  }

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const idx = monthNames.indexOf(monthName);
  const inNextYear = idx >= 0 && idx <= 2;
  const year = inNextYear ? fyStartYear + 1 : fyStartYear;
  const start = new Date(year, idx, 1, 0, 0, 0, 0);
  const end = new Date(year, idx + 1, 0, 23, 59, 59, 999);
  return { start, end };
}

const FY_MONTH_ORDER = [
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
];

const getMonthName = (date) => {
  const parsed = parseOrderDate(date);
  return parsed ? parsed.toLocaleString("en-IN", { month: "long" }) : "Unknown";
};

const getMonthSortIndex = (monthName) => {
  const i = FY_MONTH_ORDER.indexOf(monthName);
  return i >= 0 ? i : 999;
};

const getMonthLabelForRow = (rowDate, fyStartYear) => {
  const d = parseOrderDate(rowDate);
  if (!d) return "Unknown date";

  const monthName = getMonthName(d);
  const month = d.getMonth() + 1;
  const year = month >= 4 ? fyStartYear : fyStartYear + 1;
  return `${monthName} ${year}`;
};

const buildGroupKey = (rowDate, fyStartYear) => {
  const d = parseOrderDate(rowDate);
  if (!d) return `${fyStartYear}__Unknown`;

  const monthName = getMonthName(d);
  return `${fyStartYear}__${monthName}`;
};

const sumRows = (list = []) => ({
  amount: list.reduce((a, r) => a + N(r?.amount), 0),
  igstTotal: list.reduce((a, r) => a + N(r?.igstTotal), 0),
  cgstTotal: list.reduce((a, r) => a + N(r?.cgstTotal), 0),
  sgstTotal: list.reduce((a, r) => a + N(r?.sgstTotal), 0),
  roundOff: list.reduce((a, r) => a + N(r?.roundOff), 0),
  grandTotal: list.reduce((a, r) => a + N(r?.grandTotal), 0),
});

function groupRowsByMonth(list = [], fyStartYear) {
  const map = new Map();

  list.forEach((row) => {
    const dateValue = row?.date || row?.createdAt;
    const key = buildGroupKey(dateValue, fyStartYear);
    const monthName = getMonthName(dateValue);

    if (!map.has(key)) {
      map.set(key, {
        key,
        monthName,
        monthLabel: getMonthLabelForRow(dateValue, fyStartYear),
        rows: [],
      });
    }

    map.get(key).rows.push(row);
  });

  const groups = Array.from(map.values()).map((g) => {
    const sortedRows = [...g.rows].sort((a, b) => {
      const da = parseOrderDate(a?.date || a?.createdAt)?.getTime() || 0;
      const db = parseOrderDate(b?.date || b?.createdAt)?.getTime() || 0;
      if (da === db) return Number(b.invoiceId || 0) - Number(a.invoiceId || 0);
      return db - da;
    });

    return {
      ...g,
      rows: sortedRows,
      totals: sumRows(sortedRows),
    };
  });

  groups.sort((a, b) => {
    const ai = getMonthSortIndex(a.monthName);
    const bi = getMonthSortIndex(b.monthName);
    if (ai !== bi) return ai - bi;
    return a.monthLabel.localeCompare(b.monthLabel);
  });

  return groups;
}

const getCurrentOpenMonthKey = (fyYear) => {
  const now = new Date();
  const month = now.getMonth() + 1;
  const rowFY = month >= 4 ? now.getFullYear() : now.getFullYear() - 1;
  if (rowFY !== fyYear) return null;
  return `${fyYear}__${getMonthName(now)}`;
};

const normalizeGstrOrder = (row) => ({
  ...row,
  amount: round2(
    N(
      row?.amount ??
        row?.Amount ??
        row?.taxableAmount ??
        row?.basicTotal ??
        row?.BasicTotal,
    ),
  ),
  igstTotal: round2(N(row?.igstTotal)),
  cgstTotal: round2(N(row?.cgstTotal)),
  sgstTotal: round2(N(row?.sgstTotal)),
  roundOff: round2(
    N(
      row?.roundOff ??
        row?.roundoff ??
        row?.RoundOff ??
        row?.round_off ??
        row?.Round_Off,
    ),
  ),
  grandTotal: round2(
    N(
      row?.grandTotal ??
        row?.GrandTotal ??
        row?.grand_total ??
        row?.totalAmount ??
        row?.TotalAmount,
    ),
  ),
});

/* ============== Component ============== */
export default function SalesInvoiceList() {
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  const [permissions, setPermissions] = useState({
    View: true,
    Create: true,
    Edit: true,
    Delete: true,
    Download: true,
  });

  const [allRegular, setAllRegular] = useState([]);
  const [allUnregister, setAllUnregister] = useState([]);
  const [rows, setRows] = useState([]);
  const [activeBucket, setActiveBucket] = useState("REGULAR");
  const [search, setSearch] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);

  const monthNames = useMemo(
    () => [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    [],
  );

  const financialYearSelected = useMemo(() => {
    const storedFY = localStorage.getItem("financialYearSelected");
    if (storedFY) return normalizeFY(storedFY);

    let storedUser = {};
    try {
      storedUser = JSON.parse(localStorage.getItem("userData") || "{}");
    } catch {
      storedUser = {};
    }

    const storedDatabase =
      storedUser?.database ||
      storedUser?.Database ||
      localStorage.getItem("database") ||
      localStorage.getItem("Database") ||
      "";

    const match = toStr(storedDatabase).match(/(\d{4}-(?:\d{2}|\d{4}))$/);
    return match ? normalizeFY(match[1]) : "";
  }, []);

  // IMPORTANT: filtering must follow the selected FY/database, not today's FY.
  // Example: database-2025-26 must use 01-Apr-2025 to 31-Mar-2026.
  const fyStartYear = useMemo(
    () => getSelectedFYStartYear(financialYearSelected),
    [financialYearSelected],
  );
  const [periodType, setPeriodType] = useState("YEARLY");
  const [selectedMonth, setSelectedMonth] = useState("April");
  const [selectedQuarter, setSelectedQuarter] = useState("Q1");
  const [selectedHalf, setSelectedHalf] = useState("H1");
  const [filterLoading, setFilterLoading] = useState(false);

  const [monthOpenMap, setMonthOpenMap] = useState({});

  const [modalCols, setModalCols] = useState(false);
  const addBufferRef = useRef([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [showEwayInput, setShowEwayInput] = useState(false);
  const [ewayBillInput, setEwayBillInput] = useState("");
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const [cnModal, setCnModal] = useState(false);
  const [cnForm, setCnForm] = useState({
    CNNumber: "",
    CNDate: "",
    CNQty: "",
    CNImage: null,
    CNImageBase64: "",
  });

  const [emailLoader, setEmailLoader] = useState(false);

  const [showQR, setShowQR] = useState(false);
  const [qrImage, setQrImage] = useState("");
  const [selectedInvoiceId, setSelectedInvoiceId] = useState("");
  const [paidAmount, setPaidAmount] = useState(0);
  const [transactionDetails, setTransactionDetails] = useState({
    utrNumber: "",
    date: "",
    time: "",
  });

  useEffect(() => injectOnce(), []);

  const openQR = (row) => {
    setShowQR(true);
    setQrImage(`${baseURL}/Images/${row?.qrCode}`);
    setSelectedInvoiceId(row?._id || "");
    setPaidAmount(row?.amount || 0);
  };

  const closeQR = () => {
    setShowQR(false);
    setQrImage("");
    setSelectedInvoiceId("");
    setPaidAmount(0);
    setTransactionDetails({
      utrNumber: "",
      date: "",
      time: "",
    });
  };

  const savePayment = async () => {
    try {
      const { utrNumber, date, time } = transactionDetails;

      if (!utrNumber) {
        swal("Please paste transaction details after payment");
        return;
      }

      const payload = {
        id: selectedInvoiceId,
        paidAmount: parseFloat(paidAmount),
        transactionDetails: {
          utrNumber: utrNumber,
          date: date || new Date().toLocaleDateString(),
          time: time || new Date().toLocaleTimeString(),
        },
      };

      const res = await axios.post(
        `${baseURL}/order/first-step-payment`,
        payload,
      );

      if (res?.data?.message) {
        swal({
          title: "Success",
          text: "Payment Successful",
          icon: "success",
          button: "OK",
        });

        closeQR();
        await refreshFromServer();
      }
    } catch (error) {
      console.log(error);
      swal("Error in saving payment");
    }
  };

  /* ===== columns ===== */
  const baseColumns = useMemo(
    () => [
      { key: "status", header: "STATUS", get: (r) => r?.status },
      {
        key: "invoice",
        header: "INVOICE",
        get: (r) => (r?.invoiceId === undefined ? "-" : "icon"),
        render: (r) =>
          r?.invoiceId === undefined ? (
            "-"
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              <AiOutlineDownload
                title="Invoice Options"
                size={18}
                color="blue"
                onClick={() => handleInvoiceOptions(r)}
                style={{ cursor: "pointer" }}
              />

              {r?.paymentVerified ? (
                <span
                  style={{
                    color: "green",
                    fontWeight: 700,
                    fontSize: 12,
                  }}
                >
                  Paid
                </span>
              ) : (
                <button
                  type="button"
                  style={{
                    background: "#28a745",
                    color: "#fff",
                    border: "none",
                    padding: "0 8px",
                    fontSize: "11px",
                    height: "24px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => openQR(r)}
                >
                  Pay Now
                </button>
              )}
            </div>
          ),
      },
      {
        key: "invoiceId",
        header: "INVOICE NO.",
        get: (r) => {
          if (r?.invoiceId === undefined) return "Total";

          const company = JSON.parse(
            localStorage.getItem("Companydetail") || "{}",
          );

          return formatInvoiceNoByFY(r, company);
        },
      },
      { key: "date", header: "DATE", get: (r) => fmtDate(r?.date) },
      {
        key: "party",
        header: "PARTY NAME",
        get: (r) => r?.partyId?.CompanyName || r?.fullName,
        render: (r) => (
          <LinkCell
            title="Edit invoice"
            onClick={() => navigate(`/app/sales-invoices/edit/${r?._id}`)}
          >
            {r?.partyId?.CompanyName || r?.fullName || ""}
          </LinkCell>
        ),
      },
      {
        key: "limit",
        header: "PARTY LIMIT",
        get: (r) => r?.partyId?.limit || "",
      },
      { key: "amount", header: "BASIC TOTAL", get: (r) => INR(r?.amount) },
      { key: "igstTotal", header: "IGST", get: (r) => INR(r?.igstTotal) },
      {
        key: "cgstTotal",
        header: "CGST",
        get: (r) => (typeof r?.cgstTotal === "number" ? INR(r.cgstTotal) : ""),
      },
      { key: "sgstTotal", header: "SGST", get: (r) => INR(N(r?.sgstTotal)) },
      { key: "roundOff", header: "ROUND OFF", get: (r) => INR(r?.roundOff) },
      {
        key: "grandTotal",
        header: "GRAND TOTAL",
        get: (r) => INR(r?.grandTotal),
      },
    ],
    [navigate],
  );

  const [selectedKeys, setSelectedKeys] = useState([]);
  useEffect(() => {
    const raw = localStorage.getItem("CompleteOrderList");
    let next = [];
    try {
      const parsed = raw ? JSON.parse(raw) : null;
      if (Array.isArray(parsed) && parsed.length) {
        const keys = new Set(baseColumns.map((c) => c.key));
        next = parsed.filter((k) => keys.has(k));
      }
    } catch {}
    if (!next.length) next = baseColumns.map((c) => c.key);
    setSelectedKeys(next);
  }, [baseColumns]);

  const colMap = useMemo(() => {
    const map = new Map();
    baseColumns.forEach((c) => map.set(c.key, c));
    return map;
  }, [baseColumns]);

  const visibleCols = useMemo(
    () => selectedKeys.map((k) => colMap.get(k)).filter(Boolean),
    [selectedKeys, colMap],
  );

  /* ===== fetch + cache ===== */
  const fetchCompletedOnce = async () => {
    const user = JSON.parse(localStorage.getItem("userData") || "{}");

    const inside = CheckPermission("Complete Order");
    if (inside && typeof inside === "object") {
      setPermissions((p) => ({ ...p, ...inside }));
    }

    const database =
      user?.database ||
      user?.Database ||
      localStorage.getItem("database") ||
      localStorage.getItem("Database") ||
      "";

    if (!database) {
      throw new Error("Database not found in localStorage userData.");
    }

    const selectedDatabase = buildFinancialYearDatabase(
      database,
      financialYearSelected,
    );

    const res = await _Get(
      "/order/sales-invoice-list-lite/",
      encodeURIComponent(selectedDatabase),
    );

    // The API helper may return either response.data or the payload directly.
    // It may also use b2b/b2cs/b2cl or b2bData/b2csData/b2clData keys.
    const payload = res?.data?.data ?? res?.data ?? res ?? {};

    const pickArray = (...keys) => {
      const containers = [
        payload,
        payload?.data,
        payload?.result,
        res,
        res?.data,
        res?.data?.data,
      ];

      for (const container of containers) {
        if (!container || typeof container !== "object") continue;
        for (const key of keys) {
          if (Array.isArray(container?.[key])) return container[key];
        }
      }

      return [];
    };

    const b2bRows = pickArray("b2bData", "b2b", "B2B", "regularData");
    const b2csRows = pickArray("b2csData", "b2cs", "B2CS");
    const b2clRows = pickArray("b2clData", "b2cl", "B2CL");

    const regular = b2bRows.filter(isCompletedOrder).map(normalizeGstrOrder);

    const unregister = [...b2csRows, ...b2clRows]
      .filter(isCompletedOrder)
      .map(normalizeGstrOrder);

    const sorter = (a, b) => {
      const da = parseOrderDate(a?.date || a?.createdAt)?.getTime() || 0;
      const db = parseOrderDate(b?.date || b?.createdAt)?.getTime() || 0;
      if (da === db) return Number(b.invoiceId || 0) - Number(a.invoiceId || 0);
      return db - da;
    };

    regular.sort(sorter);
    unregister.sort(sorter);

    setAllRegular(regular);
    setAllUnregister(unregister);

    return { regular, unregister };
  };

  const applyPeriodFilter = (
    regularList,
    unregisterList,
    bucket = activeBucket,
  ) => {
    const sourceList =
      bucket === "REGULAR"
        ? Array.isArray(regularList)
          ? regularList
          : []
        : Array.isArray(unregisterList)
          ? unregisterList
          : [];

    const { start, end } = computeRange({
      fyStartYear,
      periodType,
      monthName: selectedMonth,
      quarter: selectedQuarter,
      half: selectedHalf,
    });

    const filtered = sourceList.filter((x) => {
      const d = parseOrderDate(x?.date || x?.createdAt);
      return d && d >= start && d <= end;
    });

    filtered.sort((a, b) => {
      const da = parseOrderDate(a?.date || a?.createdAt)?.getTime() || 0;
      const db = parseOrderDate(b?.date || b?.createdAt)?.getTime() || 0;
      if (da === db) return Number(b.invoiceId || 0) - Number(a.invoiceId || 0);
      return db - da;
    });

    setRows(filtered);
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      setErrorMsg("");
      try {
        const data = await fetchCompletedOnce();
        applyPeriodFilter(data.regular, data.unregister, "REGULAR");
      } catch (e) {
        console.error("[CompleteOrder] fetch error:", e);
        setErrorMsg(
          e?.response?.data?.message ||
            e?.message ||
            "Unable to load sales completed list.",
        );
        setAllRegular([]);
        setAllUnregister([]);
        setRows([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (loading) return;
    setFilterLoading(true);
    setErrorMsg("");
    try {
      applyPeriodFilter(allRegular, allUnregister, activeBucket);
    } catch (e) {
      setErrorMsg(e?.message || "Unable to apply filter.");
    } finally {
      setFilterLoading(false);
    }
  }, [
    fyStartYear,
    periodType,
    selectedMonth,
    selectedQuarter,
    selectedHalf,
    activeBucket,
    allRegular,
    allUnregister,
  ]); // eslint-disable-line

  const refreshFromServer = async () => {
    setFilterLoading(true);
    setErrorMsg("");
    try {
      const data = await fetchCompletedOnce();
      applyPeriodFilter(data.regular, data.unregister, activeBucket);
    } catch (e) {
      setErrorMsg(e?.message || "Unable to refresh.");
    } finally {
      setFilterLoading(false);
    }
  };

  /* ===== column chooser ===== */
  const openCols = () => {
    addBufferRef.current = [];
    setSelectedIndex(-1);
    setModalCols(true);
  };
  const closeCols = () => setModalCols(false);

  const handleCheckbox = (checked, colKey) => {
    const buf = addBufferRef.current.slice();
    if (checked) {
      if (!buf.includes(colKey)) buf.push(colKey);
    } else {
      const i = buf.indexOf(colKey);
      if (i >= 0) buf.splice(i, 1);
    }
    addBufferRef.current = buf;
  };

  const addSelectedColumns = () => {
    const next = Array.from(
      new Set([...selectedKeys, ...addBufferRef.current]),
    );
    setSelectedKeys(next);
  };

  const removeAtIndex = () => {
    if (selectedIndex < 0) return;
    const next = selectedKeys.slice();
    next.splice(selectedIndex, 1);
    setSelectedKeys(next);
    setSelectedIndex(-1);
  };

  const shiftUp = () => {
    if (selectedIndex <= 0) return;
    const next = selectedKeys.slice();
    const el = next.splice(selectedIndex, 1)[0];
    next.splice(selectedIndex - 1, 0, el);
    setSelectedKeys(next);
    setSelectedIndex(selectedIndex - 1);
  };

  const shiftDown = () => {
    if (selectedIndex < 0 || selectedIndex >= selectedKeys.length - 1) return;
    const next = selectedKeys.slice();
    const el = next.splice(selectedIndex, 1)[0];
    next.splice(selectedIndex + 1, 0, el);
    setSelectedKeys(next);
    setSelectedIndex(selectedIndex + 1);
  };

  const applyColumns = (e) => {
    e.preventDefault();
    localStorage.setItem("CompleteOrderList", JSON.stringify(selectedKeys));
    closeCols();
  };

  const deleteSelected = async () => {
    if (!selectedIds.length) return;
    const ok = await swal({
      title: "Are you sure?",
      text: "You are about to delete all selected items.",
      icon: "warning",
      buttons: ["Cancel", "Yes, delete all!"],
      dangerMode: true,
    });
    if (!ok) return;

    try {
      const res = await _DeleteAllSales("/order/delete-multiple", {
        sales: selectedIds,
      });
      if (res?.status) {
        await swal("Deleted!", "Selected items have been deleted.", "success");

        if (activeBucket === "REGULAR") {
          setAllRegular((prev) =>
            prev.filter((r) => !selectedIds.includes(r._id)),
          );
        } else {
          setAllUnregister((prev) =>
            prev.filter((r) => !selectedIds.includes(r._id)),
          );
        }

        setRows((prev) => prev.filter((r) => !selectedIds.includes(r._id)));
        clearGlobalSalesFastCaches();
        setSelectedIds([]);
      } else {
        await swal("Error!", "Something went wrong while deleting.", "error");
      }
    } catch {
      await swal("Error!", "Something went wrong while deleting.", "error");
    }
  };

  /* ===== invoice options flow ===== */
  const handleInvoiceOptions = async (row) => {
    let fullRow = row;
    try {
      const detail = await _Get("/order/sales-order-by-id/", row?._id);
      fullRow = detail?.orderHistory || detail?.order || detail?.Order || row;
    } catch {
      // Keep the list row as a safe fallback if the detail request fails.
    }
    setSelectedInvoice(fullRow);
    const needEWay = N(fullRow?.grandTotal) >= 50000;
    const hasARN = Array.isArray(fullRow?.ARN)
      ? fullRow.ARN.length > 0
      : !!toStr(fullRow?.ARN);
    if (needEWay && !hasARN) {
      setShowEwayInput(true);
    } else {
      setShowOptionsModal(true);
    }
  };

  const submitEway = async () => {
    if (!ewayBillInput) {
      swal("Please enter E-Way Bill number");
      return;
    }
    try {
      await _PutUpdate(arnSave, selectedInvoice?._id, { ARN: ewayBillInput });
      swal("E-Way Bill saved");

      setAllRegular((prev) =>
        prev.map((r) =>
          r._id === selectedInvoice?._id ? { ...r, ARN: ewayBillInput } : r,
        ),
      );
      setAllUnregister((prev) =>
        prev.map((r) =>
          r._id === selectedInvoice?._id ? { ...r, ARN: ewayBillInput } : r,
        ),
      );
      setRows((prev) =>
        prev.map((r) =>
          r._id === selectedInvoice?._id ? { ...r, ARN: ewayBillInput } : r,
        ),
      );
    } catch {
      swal("Error saving E-Way Bill");
    } finally {
      setShowEwayInput(false);
      setShowOptionsModal(true);
    }
  };

  /* ===== PDF generation ===== */
  const generateInvoicePDF = async () => {
    try {
      const row = selectedInvoice;
      if (!row) return null;

      const company = JSON.parse(localStorage.getItem("Companydetail") || "{}");
      const hydratedRow = await hydrateInvoiceMasterDetails(row);
      const printPayload = buildPrintableInvoice(hydratedRow, company);

      let ledgerNumbers = {
        creditBalance: "0.00",
        debitBalance: "0.00",
        closingBalance: "0.00",
      };
      try {
        const res = await _Get(Last_Ledger_Balance, row?.partyId?._id);
        const led = res?.Ledger || {};
        const credit = N(led?.credit);
        const debit = N(led?.debit);
        ledgerNumbers = {
          creditBalance: credit.toFixed(2),
          debitBalance: debit.toFixed(2),
          closingBalance: (debit - credit).toFixed(2),
        };
      } catch {}

      const wordsNumber = toWords.convert(N(printPayload.grandTotal));

      const BilData = {
        CompanyDetails: company,
        PrintData: printPayload,
        wordsNumber,
      };

      const blob = await pdf(
        <LatestInvoice
          invoiceData={printPayload}
          CollectedData={ledgerNumbers}
          BilData={BilData}
          tableList={printPayload?.orderItems || []}
          AllCharges={printPayload?.discountDetails || []}
          fileName="invoice.pdf"
        />,
      ).toBlob();
      return blob;
    } catch (err) {
      console.error("PDF blob error:", err);
      return null;
    }
  };

  const downloadPdf = async () => {
    if (!selectedInvoice) return;
    const blob = await generateInvoicePDF();
    if (!blob) {
      swal("Failed to generate PDF.");
      return;
    }

    const company = JSON.parse(localStorage.getItem("Companydetail") || "{}");
    const fileNameId = formatInvoiceNoByFY(selectedInvoice, company);

    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `${
      selectedInvoice?.partyId?.CompanyName ||
      selectedInvoice?.fullName ||
      "invoice"
    }-${fileNameId}.pdf`;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  const viewPdf = async () => {
    if (!selectedInvoice) return;
    const blob = await generateInvoicePDF();
    if (!blob) {
      swal("Failed to generate PDF.");
      return;
    }
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank", "noopener,noreferrer");
    setTimeout(() => URL.revokeObjectURL(url), 60 * 1000);
  };

  const sendInvoiceEmail = async () => {
    if (!selectedInvoice) return;
    setEmailLoader(true);
    try {
      const blob = await generateInvoicePDF();
      if (!blob) throw new Error("PDF gen failed");

      const company = JSON.parse(localStorage.getItem("Companydetail") || "{}");
      const invoiceNoForEmail = formatInvoiceNoByFY(selectedInvoice, company);

      const fd = new FormData();
      const email =
        selectedInvoice?.partyId?.email || selectedInvoice?.email || "";
      const rawDate = selectedInvoice?.date;
      const formattedDate = rawDate
        ? new Date(rawDate).toLocaleDateString("en-GB")
        : "";

      fd.append("invoice", blob, "invoice.pdf");

      if (selectedInvoice?.CNImage) {
        const cnFileName =
          String(selectedInvoice.CNImage).split("/").pop() || "cn-image.jpg";

        const cnImageResponse = await axios.get(
          `${baseURL}/Images/${encodeURIComponent(cnFileName)}`,
          {
            responseType: "blob",
          },
        );

        fd.append("cnImage", cnImageResponse.data, cnFileName);
      }
      fd.append("customer", email);
      fd.append("title", "This is a computer-generated invoice");
      fd.append("date", formattedDate);
      fd.append("total", N(selectedInvoice?.grandTotal));
      fd.append("invoiceId", invoiceNoForEmail);
      fd.append(
        "partyName",
        selectedInvoice?.partyId?.CompanyName ||
          selectedInvoice?.fullName ||
          "",
      );
      fd.append(
        "address",
        selectedInvoice?.partyId?.ownerAddress ||
          selectedInvoice?.ownerAddress ||
          selectedInvoice?.address ||
          "",
      );
      fd.append("CNDate", selectedInvoice?.CNDate || "--");
      fd.append("CNNumber", selectedInvoice?.CNNumber || "--");
      fd.append("CNQty", selectedInvoice?.CNQty || "--");

      const user = JSON.parse(localStorage.getItem("userData") || "{}");
      fd.append("superAdminName", user?.companyName || "");
      fd.append("email", user?.email || "");
      fd.append("appPassword", user?.appPassword || "");

      await axios.post(`${baseURL}/order/send-invoice`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      swal("Invoice sent successfully!");
    } catch (e) {
      console.error(e);
      swal("Error sending invoice");
    } finally {
      setEmailLoader(false);
    }
  };

  const submitCN = async () => {
    try {
      const form = new FormData();
      form.append("CNNumber", cnForm.CNNumber || "");
      form.append("CNDate", cnForm.CNDate || "");
      form.append("CNQty", cnForm.CNQty || "");
      if (cnForm.CNImage) form.append("CNImage", cnForm.CNImage);
      await _Put(updatedCNData, selectedInvoice?._id, form);
      swal("CN Data updated");
      setCnModal(false);
      setShowOptionsModal(false);
    } catch (e) {
      console.error(e);
      setShowOptionsModal(false);
    }
  };

  /* ===== search, grouping, totals ===== */
  const filteredRows = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return rows;
    const searchCols = visibleCols.filter((c) => c.key !== "invoice");
    return rows.filter((r) =>
      searchCols.some((c) => toStr(c.get(r)).toLowerCase().includes(term)),
    );
  }, [rows, search, visibleCols]);

  const groupedRows = useMemo(() => {
    return groupRowsByMonth(filteredRows, fyStartYear);
  }, [filteredRows, fyStartYear]);

  useEffect(() => {
    const next = {};
    groupedRows.forEach((g) => {
      next[g.key] = true;
    });

    const currentOpenKey = getCurrentOpenMonthKey(fyStartYear);
    if (currentOpenKey && next[currentOpenKey] !== undefined) {
      next[currentOpenKey] = true;
    }

    setMonthOpenMap(next);
  }, [groupedRows, fyStartYear, activeBucket]);

  const totals = useMemo(() => {
    const sum = (key) =>
      filteredRows.reduce((acc, r) => acc + (Number(r?.[key]) || 0), 0);
    return {
      amount: sum("amount"),
      igstTotal: sum("igstTotal"),
      cgstTotal: sum("cgstTotal"),
      sgstTotal: sum("sgstTotal"),
      roundOff: sum("roundOff"),
      grandTotal: sum("grandTotal"),
    };
  }, [filteredRows]);

  /* ===== export ===== */
  const handleExportXLSX = async () => {
    const cols = visibleCols.filter((c) => c.key !== "invoice");
    const data = [];

    groupedRows.forEach((group) => {
      const monthTotalRow = {};
      cols.forEach((c) => {
        if (c.key === "party")
          monthTotalRow[c.header] = `${group.monthLabel} TOTAL`;
        else if (c.key === "amount")
          monthTotalRow[c.header] = INR(group.totals.amount);
        else if (c.key === "igstTotal")
          monthTotalRow[c.header] = INR(group.totals.igstTotal);
        else if (c.key === "cgstTotal")
          monthTotalRow[c.header] = INR(group.totals.cgstTotal);
        else if (c.key === "sgstTotal")
          monthTotalRow[c.header] = INR(group.totals.sgstTotal);
        else if (c.key === "roundOff")
          monthTotalRow[c.header] = INR(group.totals.roundOff);
        else if (c.key === "grandTotal")
          monthTotalRow[c.header] = INR(group.totals.grandTotal);
        else monthTotalRow[c.header] = "";
      });
      data.push(monthTotalRow);

      group.rows.forEach((r) => {
        const obj = {};
        cols.forEach((c) => (obj[c.header] = toStr(c.get(r))));
        data.push(obj);
      });
    });

    const finalTotalRow = {};
    cols.forEach((c) => {
      if (c.key === "party") finalTotalRow[c.header] = "FINAL TOTAL";
      else if (c.key === "amount") finalTotalRow[c.header] = INR(totals.amount);
      else if (c.key === "igstTotal")
        finalTotalRow[c.header] = INR(totals.igstTotal);
      else if (c.key === "cgstTotal")
        finalTotalRow[c.header] = INR(totals.cgstTotal);
      else if (c.key === "sgstTotal")
        finalTotalRow[c.header] = INR(totals.sgstTotal);
      else if (c.key === "roundOff")
        finalTotalRow[c.header] = INR(totals.roundOff);
      else if (c.key === "grandTotal")
        finalTotalRow[c.header] = INR(totals.grandTotal);
      else finalTotalRow[c.header] = "";
    });
    data.push(finalTotalRow);

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([buf], { type: "application/octet-stream" }),
      `CompletedOrderList_${activeBucket}.xlsx`,
    );
  };

  const toggleMonth = (key) => {
    setMonthOpenMap((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  /* ===== render ===== */
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20rem",
        }}
      >
        <Spinner style={{ height: "4rem", width: "4rem" }} color="primary">
          Loading...
        </Spinner>
      </div>
    );
  }

  const noData = !groupedRows?.length;

  return (
    <>
      {errorMsg && (
        <Row>
          <Col sm="12">
            <Alert color="danger" style={{ marginBottom: 10 }}>
              {errorMsg}
            </Alert>
          </Col>
        </Row>
      )}

      <Row className="co-toolbar" style={{ marginBottom: 10 }}>
        <Col sm="12">
          <div className="co-toolbar-shell">
            <div className="co-row">
              <div className="co-mini-tabs">
                <button
                  type="button"
                  className={`co-mini-tab ${activeBucket === "REGULAR" ? "active" : ""}`}
                  onClick={() => setActiveBucket("REGULAR")}
                >
                  Regular
                </button>
                <button
                  type="button"
                  className={`co-mini-tab ${activeBucket === "UNREGISTER" ? "active" : ""}`}
                  onClick={() => setActiveBucket("UNREGISTER")}
                >
                  UnRegister
                </button>
              </div>

              <div className="co-search">
                <Input
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              <div className="co-field">
                <span className="lbl">Period</span>
                <select
                  className="sm"
                  value={periodType}
                  onChange={(e) => {
                    const v = e.target.value;
                    setPeriodType(v);
                    if (v === "MONTHLY") setSelectedMonth("April");
                    if (v === "QUARTERLY") setSelectedQuarter("Q1");
                    if (v === "HALF_YEARLY") setSelectedHalf("H1");
                  }}
                  disabled={filterLoading}
                >
                  <option value="MONTHLY">Monthly</option>
                  <option value="QUARTERLY">Quarterly</option>
                  <option value="HALF_YEARLY">Half Yearly</option>
                  <option value="YEARLY">Yearly</option>
                </select>
              </div>

              {periodType === "MONTHLY" && (
                <div className="co-field">
                  <span className="lbl">Month</span>
                  <select
                    className="sm"
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    disabled={filterLoading}
                  >
                    {monthNames.map((m) => (
                      <option key={m} value={m}>
                        {m}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {periodType === "QUARTERLY" && (
                <div className="co-field">
                  <span className="lbl">Quarter</span>
                  <select
                    className="xs"
                    value={selectedQuarter}
                    onChange={(e) => setSelectedQuarter(e.target.value)}
                    disabled={filterLoading}
                  >
                    <option value="Q1">Q1 (Apr-Jun)</option>
                    <option value="Q2">Q2 (Jul-Sep)</option>
                    <option value="Q3">Q3 (Oct-Dec)</option>
                    <option value="Q4">Q4 (Jan-Mar)</option>
                  </select>
                </div>
              )}

              {periodType === "HALF_YEARLY" && (
                <div className="co-field">
                  <span className="lbl">Half</span>
                  <select
                    className="xs"
                    value={selectedHalf}
                    onChange={(e) => setSelectedHalf(e.target.value)}
                    disabled={filterLoading}
                  >
                    <option value="H1">H1 (Apr-Sep)</option>
                    <option value="H2">H2 (Oct-Mar)</option>
                  </select>
                </div>
              )}

              {filterLoading && (
                <span className="co-chip" title="Loading">
                  <Spinner size="sm" /> Loading
                </span>
              )}

              {/* <button
                type="button"
                className="co-btn-soft"
                onClick={refreshFromServer}
                title="Refresh from server"
                disabled={filterLoading}
              >
                Refresh
              </button> */}

              {permissions?.Download && (
                <button
                  type="button"
                  className="co-btn-soft"
                  onClick={handleExportXLSX}
                  title="Download list Excel"
                >
                  <FaFileExcel size={16} />
                  Excel
                </button>
              )}

              <button
                type="button"
                className="co-btn-soft"
                onClick={openCols}
                title="Choose columns"
              >
                <FaSlidersH size={14} />
                Columns
              </button>

              <Button
                color="primary"
                style={{
                  height: 32,
                  borderRadius: 12,
                  fontWeight: 900,
                  textTransform: "uppercase",
                  whiteSpace: "nowrap",
                }}
                onClick={() => navigate("/app/sales-invoices/create")}
              >
                + Invoice
              </Button>

              {/* <Button
                color="primary"
                style={{
                  height: 32,
                  borderRadius: 12,
                  fontWeight: 900,
                  textTransform: "uppercase",
                  whiteSpace: "nowrap",
                }}
                onClick={() => navigate("/app/challans/create")}
              >
                + Challan
              </Button> */}

              {selectedIds.length > 0 && (
                <Button
                  color="danger"
                  style={{ height: 32, borderRadius: 12, whiteSpace: "nowrap" }}
                  onClick={deleteSelected}
                >
                  Delete All
                </Button>
              )}
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col sm="12">
          <Card className="co-card" style={{ padding: 8 }}>
            {noData ? (
              <div
                style={{ padding: 24, textAlign: "center", color: "#6b7280" }}
              >
                No data found.
              </div>
            ) : (
              <div className="co-table-wrap">
                <table className="co-table">
                  <thead>
                    <tr>
                      {visibleCols.map((c) => (
                        <th key={c.key}>{c.header}</th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {groupedRows.map((group) => (
                      <React.Fragment key={group.key}>
                        <tr
                          className="co-month-row"
                          onClick={() => toggleMonth(group.key)}
                        >
                          {visibleCols.map((c, idx) => {
                            if (idx === 0) {
                              return (
                                <td key={c.key}>
                                  <div className="co-month-cell">
                                    {monthOpenMap[group.key] ? (
                                      <FaChevronDown />
                                    ) : (
                                      <FaChevronRight />
                                    )}
                                    <span>{group.monthLabel}</span>
                                  </div>
                                </td>
                              );
                            }

                            if (c.key === "party") {
                              return (
                                <td key={c.key}>
                                  <span className="co-month-muted">
                                    Month Total
                                  </span>
                                </td>
                              );
                            }

                            if (c.key === "amount") {
                              return (
                                <td key={c.key}>{INR(group.totals.amount)}</td>
                              );
                            }
                            if (c.key === "igstTotal") {
                              return (
                                <td key={c.key}>
                                  {INR(group.totals.igstTotal)}
                                </td>
                              );
                            }
                            if (c.key === "cgstTotal") {
                              return (
                                <td key={c.key}>
                                  {INR(group.totals.cgstTotal)}
                                </td>
                              );
                            }
                            if (c.key === "sgstTotal") {
                              return (
                                <td key={c.key}>
                                  {INR(group.totals.sgstTotal)}
                                </td>
                              );
                            }
                            if (c.key === "roundOff") {
                              return (
                                <td key={c.key}>
                                  {INR(group.totals.roundOff)}
                                </td>
                              );
                            }
                            if (c.key === "grandTotal") {
                              return (
                                <td key={c.key}>
                                  {INR(group.totals.grandTotal)}
                                </td>
                              );
                            }

                            return <td key={c.key} />;
                          })}
                        </tr>

                        {monthOpenMap[group.key] &&
                          group.rows.map((r) => (
                            <tr key={r?._id}>
                              {visibleCols.map((c) => (
                                <td key={c.key}>
                                  {typeof c.render === "function"
                                    ? c.render(r)
                                    : toStr(c.get(r))}
                                </td>
                              ))}
                            </tr>
                          ))}
                      </React.Fragment>
                    ))}

                    <tr className="co-totals">
                      {visibleCols.map((c) => {
                        if (c.key === "party") {
                          return (
                            <td key={c.key} style={{ textAlign: "right" }}>
                              Final Total:
                            </td>
                          );
                        }
                        if (
                          [
                            "amount",
                            "igstTotal",
                            "cgstTotal",
                            "sgstTotal",
                            "roundOff",
                            "grandTotal",
                          ].includes(c.key)
                        ) {
                          const val = totals[c.key] || 0;
                          return <td key={c.key}>{INR(val)}</td>;
                        }
                        return <td key={c.key} />;
                      })}
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </Card>
        </Col>
      </Row>

      <Modal
        isOpen={modalCols}
        toggle={closeCols}
        zIndex={2000}
        backdrop="static"
        keyboard={false}
        style={{ maxWidth: 1050 }}
      >
        <ModalHeader toggle={closeCols}>Change Fields</ModalHeader>
        <ModalBody>
          <Row>
            <Col lg="4" md="4" sm="12" xl="4" xs="12">
              <h5>Available Columns</h5>
              <div style={listBoxStyle}>
                {baseColumns.map((col) => (
                  <div key={col.key} style={pickItemStyle}>
                    <label
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <input
                        type="checkbox"
                        onChange={(e) =>
                          handleCheckbox(e.target.checked, col.key)
                        }
                      />
                      <span>{col.header}</span>
                    </label>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 8 }}>
                <Button size="sm" color="primary" onClick={addSelectedColumns}>
                  Add Selected →
                </Button>
              </div>
            </Col>

            <Col lg="8" md="8" sm="12" xl="8" xs="12">
              <h5>Visible Columns</h5>
              <div
                style={{ display: "flex", gap: 12, alignItems: "flex-start" }}
              >
                <div style={{ ...listBoxStyle, flex: 1 }}>
                  {selectedKeys.map((key, i) => {
                    const col = colMap.get(key);
                    if (!col) return null;
                    return (
                      <div
                        key={key}
                        style={{
                          ...pickItemStyle,
                          background: i === selectedIndex ? "#1877f2" : "#fff",
                          color: i === selectedIndex ? "#fff" : "#000",
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectedIndex(i)}
                      >
                        {col.header}
                      </div>
                    );
                  })}
                </div>
                <div style={{ display: "grid", gap: 8 }}>
                  <Button size="sm" onClick={shiftUp}>
                    ↑
                  </Button>
                  <Button size="sm" onClick={shiftDown}>
                    ↓
                  </Button>
                  <Button size="sm" color="danger" onClick={removeAtIndex}>
                    Remove
                  </Button>
                </div>
              </div>
              <div style={{ marginTop: 12, textAlign: "center" }}>
                <Button color="primary" onClick={applyColumns}>
                  Submit
                </Button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      <Modal isOpen={showEwayInput} toggle={() => setShowEwayInput(false)}>
        <ModalHeader toggle={() => setShowEwayInput(false)}>
          Enter E-Way Bill Number
        </ModalHeader>
        <ModalBody>
          <Label>E-Way Bill Number</Label>
          <Input
            value={ewayBillInput}
            onChange={(e) => setEwayBillInput(e.target.value)}
            placeholder="Enter E-Way Bill Number"
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={submitEway}>
            Submit
          </Button>
          <Button color="secondary" onClick={() => setShowEwayInput(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={showOptionsModal}
        toggle={() => setShowOptionsModal(false)}
      >
        <ModalHeader toggle={() => setShowOptionsModal(false)}>
          Choose Action
        </ModalHeader>
        <ModalBody>What would you like to do with this invoice?</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={viewPdf}>
            View
          </Button>
          <Button color="success" onClick={downloadPdf}>
            Download
          </Button>
          <Button color="success" onClick={() => setCnModal(true)}>
            Update CN Data
          </Button>
          <Button
            color="info"
            onClick={sendInvoiceEmail}
            disabled={emailLoader}
          >
            {emailLoader ? (
              <Spinner size="sm" style={{ color: "white" }} />
            ) : (
              "Send to Email"
            )}
          </Button>
          <Button color="secondary" onClick={() => setShowOptionsModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={cnModal} toggle={() => setCnModal(false)}>
        <ModalHeader toggle={() => setCnModal(false)}>
          Update CN Data
        </ModalHeader>
        <ModalBody>
          <Form className="co-form">
            <FormGroup>
              <Label for="CNImage">CN Image</Label>
              <Input
                type="file"
                id="CNImage"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (!file) return;
                  const reader = new FileReader();
                  reader.onloadend = () =>
                    setCnForm((p) => ({
                      ...p,
                      CNImage: file,
                      CNImageBase64: reader.result,
                    }));
                  reader.readAsDataURL(file);
                }}
              />
            </FormGroup>
            <FormGroup>
              <Label for="CNNumber">CN Number</Label>
              <Input
                type="text"
                id="CNNumber"
                value={cnForm.CNNumber}
                onChange={(e) =>
                  setCnForm((p) => ({ ...p, CNNumber: e.target.value }))
                }
              />
            </FormGroup>
            <FormGroup>
              <Label for="CNDate">CN Date</Label>
              <Input
                type="date"
                id="CNDate"
                value={cnForm.CNDate}
                onChange={(e) =>
                  setCnForm((p) => ({ ...p, CNDate: e.target.value }))
                }
              />
            </FormGroup>
            <FormGroup>
              <Label for="CNQty">CN Quantity</Label>
              <Input
                type="number"
                id="CNQty"
                value={cnForm.CNQty}
                onChange={(e) =>
                  setCnForm((p) => ({ ...p, CNQty: e.target.value }))
                }
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={submitCN}>
            Submit
          </Button>
          <Button color="secondary" onClick={() => setCnModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={showQR} toggle={closeQR}>
        <ModalHeader toggle={closeQR}>Scan & Pay</ModalHeader>

        <ModalBody style={{ textAlign: "center" }}>
          <img src={qrImage} alt="QR" style={{ width: "220px" }} />
          <p>Scan QR and complete payment</p>

          <textarea
            placeholder="Paste UPI Transaction Details / UTR"
            value={transactionDetails?.utrNumber || ""}
            onChange={(e) => {
              let input = e.target.value;
              let utr = "";

              try {
                const parsed = JSON.parse(input);
                utr = parsed?.transactionDetails?.utrNumber || "";
              } catch (err) {
                utr = input;
              }

              setTransactionDetails((prev) => ({
                ...prev,
                utrNumber: utr,
              }));
            }}
            style={{
              width: "100%",
              height: "80px",
              marginTop: "10px",
              padding: "6px",
            }}
          />
        </ModalBody>

        <ModalFooter>
          <Button
            color="success"
            disabled={!transactionDetails?.utrNumber}
            onClick={savePayment}
          >
            Payment Done
          </Button>

          <Button color="secondary" onClick={closeQR}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

/* little styles */
const listBoxStyle = {
  border: "1px solid #e5e7eb",
  borderRadius: 10,
  maxHeight: 280,
  overflow: "auto",
  background: "#fff",
  padding: 8,
};

const pickItemStyle = {
  padding: "8px 10px",
  borderRadius: 8,
  border: "1px solid #e5e7eb",
  marginBottom: 6,
  background: "#fff",
};
